import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
import { insideItems } from '../data/gallery';
const imagine = ['Imagine explaining risk assessment using a detailed factory hazard map.', 'Showing warehouse traffic conflicts through realistic workplace illustrations.', 'Demonstrating mechanical pinch points with enlarged technical diagrams.', 'Comparing exposed machine components with improved guarding arrangements.', 'Teaching hazardous energy through professional color-coded industrial schematics.', 'Helping students identify potential dangers within complex workplace scenarios.', 'Or explaining chemical exposure and protective equipment through clear visual references.'];
export function VisualSection() {
  return <section className="py-20 px-4 bg-white" data-id="element-338" data-mp="36bror1wunq0b">
      <div className="max-w-5xl mx-auto" data-id="element-339" data-mp="36ct3phgzkwnb">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="grid md:grid-cols-[1fr_1.4fr] gap-8 md:gap-12 items-start" data-id="element-340" data-mp="3bal30wjynl1j">
          <div data-id="element-341" data-mp="ns9zuzvp35bt">
            <h2 className="text-3xl md:text-4xl font-bold tracking-tight mb-5 text-ink uppercase" data-id="element-342" data-mp="nss7esnt55z1">
              See What You&apos;re Teaching
            </h2>
            <p className="text-xl font-semibold text-ink mb-1" data-id="element-343" data-mp="jokeske8b5vj">Workplace Safety Training Is Visual.</p>
            <p className="text-xl font-semibold text-forest mb-5" data-id="element-344" data-mp="3s4dy16zy2vga">
              Your Teaching Materials Should Be Visual Too.
            </p>
            <div className="space-y-3 text-graphite leading-relaxed" data-id="element-345" data-mp="4tnzxobwzk9h">
              <p data-id="element-346" data-mp="2pgwgzjk82j">{imagine.join(' ')}</p>
              <p className="font-semibold text-ink" data-id="element-347" data-mp="1mq0927y5mm">
                That&apos;s the advantage of a 100% visual training system.
              </p>
              <p data-id="element-348" data-mp="38g4rtt1kgoxs">
                <span className="font-semibold text-forest" data-id="element-349" data-mp="34h5qeif1nab3">WORKPLACE SAFETY ATLAS</span> is built
                around detailed workplace illustrations, technical diagrams, realistic hazard scenarios,
                industrial comparisons, instructor exercises and professional reference tools.
              </p>
            </div>
          </div>

          <div className="bg-mist border border-line rounded-2xl p-6" data-id="element-350" data-mp="1h6l48m2qdwuv">
            <p className="text-sm font-bold text-forest uppercase tracking-wider mb-4" data-id="element-351" data-mp="1m5flvkoypfde">
              Inside you’ll find:
            </p>
            <ul className="grid sm:grid-cols-2 gap-x-4 gap-y-2.5" data-id="element-352" data-mp="oj8gw9oqxl0i">
              {insideItems.map(item => <li key={item} className="flex items-start gap-2 text-sm text-graphite" data-id="element-353" data-mp="til44vjj4u3m">
                  <CheckCircle2 size={16} className="text-forest shrink-0 mt-0.5" data-id="element-354" data-mp="yea8dc6huz69" />
                  <span data-id="element-355" data-mp="13g9akiqhzq1m">{item}</span>
                </li>)}
            </ul>
          </div>
        </motion.div>

        <p className="text-center font-display text-2xl md:text-4xl font-extrabold tracking-tight text-ink mt-14" data-id="element-356" data-mp="29wuufv7c0sx3">
          <span className="text-forest" data-id="element-357" data-mp="36hxbm9g1ly3">100% VISUAL.</span> PRACTICAL. PROFESSIONAL.{' '}
          <span className="text-gold" data-id="element-358" data-mp="38av0c22wvty">BUILT TO TEACH.</span>
        </p>
      </div>
    </section>;
}